import { inject, Injectable } from '@angular/core';
import { ActiveToast, IndividualConfig, ToastrService } from 'ngx-toastr';
import { NotificationComponent } from '../components/notification/notification.component';
import { NotificationType } from '../components/notification/notification-type';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly toastr = inject(ToastrService);

  private readonly defaultMinDuration = 5000;
  private readonly defaultExtDuration = 2000;

  private readonly defaultToastConfig: Partial<IndividualConfig> = {
    closeButton: false,
    enableHtml: false,
    timeOut: this.defaultMinDuration,
    extendedTimeOut: this.defaultExtDuration,
  };

  success(msg: string, title: string = 'Success', config?: Partial<IndividualConfig>): ActiveToast<any> {
    return this.show(title, msg, NotificationType.Success, config);
  }

  error(msg: string, title: string = 'Error', config?: Partial<IndividualConfig>): ActiveToast<any> {
    return this.show(title, msg, NotificationType.Error, config);
  }

  warning(msg: string, title: string = 'Warning', config?: Partial<IndividualConfig>): ActiveToast<any> {
    return this.show(title, msg, NotificationType.Warning, config);
  }

  info(msg: string, title: string = 'Info', config?: Partial<IndividualConfig>): ActiveToast<any> {
    return this.show(title, msg, NotificationType.Info, config);
  }

  private show(title: string, message: string, type: NotificationType, config?: Partial<IndividualConfig>) {
    return this.toastr.show(message, title, {
      ...this.defaultToastConfig,
      ...config,
      toastComponent: NotificationComponent,
      payload: { type },
    });
  }
}
